module.exports = __webpack_public_path__ + "static/media/service-rbs.a50bea1a.png";